import { produce } from 'immer';
import { AppState } from './interface';
import { Actions } from './action';
import { AppAction } from './enum';
import { Device, Gigakombi, Option, OverlayView, ProductType } from '../../enum';
import { isGigaKombi, isOverlayView } from '../../util/typeGuard';
import { PRODUCT_CONFIG } from './constant';

export const initialState: AppState = {
    isLoading: false,
    error: undefined,
    overlay: {
        isLoaded: false,
        isOpen: false,
        view: OverlayView.AVAILABILITY_FORM,
    },
    gigakombi: Gigakombi.NONE,
    selected: {
        type: ProductType.CABLE,
        option: Option.NONE,
        device: Device.HOMEBOX,
    },
    products: [],
    productConfig: PRODUCT_CONFIG,
};

const appReducer = (state = initialState, action: Actions) => {
    return produce(state, (draftState) => {
        switch (action.type) {
            case AppAction.SET_LOADING:
                draftState.isLoading = action.isLoading;
                break;
            case AppAction.SET_OVERLAY_VISIBILITY:
                if (isOverlayView(action.value)) {
                    draftState.overlay.view = action.value;
                }

                draftState.overlay.isOpen = Boolean(action.value);
                break;
            case AppAction.SET_ERROR:
                draftState.error = action.error;
                break;
            case AppAction.SET_OVERLAY_LOADED:
                draftState.overlay.isLoaded = action.isLoaded;
                break;
            case AppAction.SET_SELECTED_GIGAKOMBI:
                if (isGigaKombi(action.gigakombi)) {
                    draftState.gigakombi = action.gigakombi;
                }
                break;
            case AppAction.SET_SELECTED_PRODUCT:
                draftState.selected = {
                    ...draftState.selected,
                    ...action.productEntry,
                };
                break;
            case AppAction.SET_PRODUCT_DETAILS:
                if (action.products) {
                    draftState.products = Object.values(action.products);
                }
                break;
        }
    });
};

export default appReducer;
